import Vue from 'vue';
import { attributeInt } from './helpers/index.mjs';

const componentDefinition = {
    props : [ 'data-cancelDiff' ],
    data  : {
        secondsTimer     : null,
        secondsRemaining : 0,
        cancelCountdown  : '0:00',
        showCancelOption : true,
        newLocker        : '',
    },
    computed : {
        cancelText() {
            return this.showCancelOption
                ? `Available for ${this.cancelCountdown}.`
                : 'Cancellation period has expired.'
            ;
        }
    },
    methods : {
        tick() {
            if( --this.secondsRemaining <= 0 ) {
                window.clearInterval( this.secondsTimer );
                this.showCancelOption = false;
                return;
            }

            const minutes = Math.floor( this.secondsRemaining / 60 );
            const seconds = ( this.secondsRemaining % 60 )
                .toString()
                .padStart( 2, '0' )
            ;

            this.cancelCountdown = `${minutes}:${seconds}`;
        }
    },
    beforeMount() {
        this.secondsRemaining = attributeInt(this.$el, 'data-cancel-diff') || 0;
    },
    mounted() {
        this.secondsTimer = window.setInterval( this.tick, 1000 );
        this.tick();
    }
};

const target_id      = 'order-confirmed-widget';
const target_element = document.getElementById( target_id );

target_element && new Vue({
    ...componentDefinition,
    el : target_element
});

